export default __webpack_public_path__ + "static/media/misc.a9ff54f9.png";